<template>
  <div class="d-none" />
</template>

<script>
/*
  Invisible component whose sole purpose to provide listable management for
  client groups in the EmailRecipientsEditor component, by re-defining
  its special props.  Most importantly, 'source' is set to 'customers'.
*/

import Listable from '@/components/mixins/listable';

export default {
  name: 'CustomerRecipientsListableManager',
  mixins: [Listable],
  props: {
    csearch: {
      type: String,
      default: '',
    },
    // listable options
    source: {
      type: String,
      default: 'customers',
    },
    mode: {
      type: String,
      default: 'loadMore',
    },
    pageSize: {
      type: Number,
      default: 15,
    },
    noMultiRequest: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    elements(newVal) {
      this.$emit('input', newVal);
    },
    csearch: {
      immediate: true,
      handler(newVal) {
        this.search = newVal;
      },
    },
    nextPageExists(newVal) {
      if (!newVal) {
        this.$emit('depleted');
      }
    },
  },
  mounted() {
    this.queryParams = {
      via_client_autocomplete: 1,
      ...this.queryParams,
    };
  },
};
</script>

<style lang="css" scoped>
</style>
